import React, { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { CCol, CFormGroup, CInput, CLabel } from '@coreui/react';
import { GeoMap } from '../geoMap/GeoMap';

import './geoPoint.scss';

export const GeoPoint: any = (props: any) => {
  const { register, setValue, errors, setError } = useFormContext();
  const {
    position: positionProps,
    center,
    name = "position",
    required = true,
    validationMsg,
    showSearchBox = false,
    googleMapsApiKey,
  } = props;

  const markerRef = useRef(null) as any;
  const mapRef = useRef(null) as any;
  const mapsRef = useRef(null) as any;
  const position = positionProps;

  const handleApiLoaded = ({ map, maps }: any) => {
    mapRef.current = map;
    mapsRef.current = maps;
    if (position?.lat && position?.lng) {
      addMarker({ map, maps }, position);
    }
    if (showSearchBox) {
      drawSearchBox(map, maps);
    }
    addMapClickListener({ map, maps });
  };

  const drawSearchBox = (map: any, maps: any) => {
    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'form-control geo-search';
    input.placeholder = 'Search';
    const searchBox = new maps.places.SearchBox(input);
    map.controls[maps.ControlPosition.BOTTOM_CENTER].push(input);
    map.addListener("bounds_changed", () => {
      searchBox.setBounds(map.getBounds() as google.maps.LatLngBounds);
    });
    let markers: google.maps.Marker[] = [];
    searchBox.addListener("places_changed", () => {
      const places = searchBox.getPlaces();

      if (places.length === 0) {
        return;
      }

      markers.forEach((marker) => {
        marker.setMap(null);
      });
      markers = [];

      const bounds = new maps.LatLngBounds();
      places.forEach((place: any) => {
        if (!place.geometry || !place.geometry.location) {
          return;
        }

        markers.push(
          new maps.Marker({
            map,
            title: place.name,
            position: place.geometry.location,
          })
        );

        setPosition({ lat:  place.geometry.location.lat(), lng: place.geometry.location.lng() });
        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      map.fitBounds(bounds);
    });
  };

  const setPosition = (position: any) => {
    setValue(name, `${position?.lat} ${position?.lng}`);
    setError(name, {});
  };

  const addMarker = ({ map, maps }: any, position: any) => {
    if (markerRef.current) {
      markerRef.current.setMap(null);
    }

    markerRef.current = new maps.Marker({
      position,
      map,
      draggable: true,
    });

    setPosition(position);
    markerRef.current.addListener('dragend', ({ latLng }: any) => {
      setPosition({ lat: latLng.lat(), lng: latLng.lng() });
    });
  };

  const addMapClickListener = ({ map, maps }: any) => {
    maps.event.addListener(map, 'click', ({ latLng }: any) => {
      const position = { lat: latLng.lat(), lng: latLng.lng() };
      addMarker({ map, maps }, position);
    });
  };

  useEffect(() => {
    if (mapRef.current && mapsRef.current) {
      addMarker({ map: mapRef.current, maps: mapsRef.current }, positionProps);
    }
  // eslint-disable-next-line
  }, [positionProps]);

  return (
    <>
      <GeoMap
        className="geo-map"
        position={position}
        handleApiLoaded={handleApiLoaded}
        center={center}
        isMarkerShown
        hasError={errors?.[name]?.type}
        errorMsg={errors?.[name]?.message}
        googleMapsApiKey={googleMapsApiKey}
      />
      <CFormGroup row className="d-none">
        <CLabel col htmlFor="position">Position</CLabel>
        <CCol sm="8">
          <CInput
            name={name}
            type="text"
            innerRef={required ? register({ required: (validationMsg || required) }) : register()}
          />
        </CCol>
      </CFormGroup>
    </>
  );
};
